<template>
    <div class="slideshowimg">
        <div @click="prev" class="left"><i class="el-icon-arrow-left"></i></div>
        <div @touchend="end" @touchstart="start" @touchmove="move" class="swiper">
            <div
                @click="chooseItem(item, index)"
                v-for="(item, index) in imgs"
                :style="config5[index]"
                :key="item.cover"
            >
                <img :src="item.cover" style="width: 100%; height: 100%" />
            </div>
        </div>
        <div @click="next" class="left"><i class="el-icon-arrow-right"></i></div>
    </div>
</template>
<script>
export default {
    name: 'zt',
    props: ['list'],
    data() {
        return {
            loading: true,
            currentIndex: 3, //当前中间imgs数组中index
            centerInfo: '', // 当前中间信息
            startX: '',
            endX: '',
            imgs: [],
            previous: 0,
            config5: [
                {
                    id: 'A', //第二张
                    position: 'absolute',
                    width: '25%',
                    height: '300px',
                    top: '10%',
                    left: '19%',
                    opacity: 1,
                    zIndex: 1,
                    transition: '.4s',
                },
                {
                    id: 'B', //第一张
                    position: 'absolute',
                    width: '25%',
                    height: '300px',
                    top: '0',
                    left: '5%',
                    opacity: 2,
                    zIndex: 0,
                    transition: '.4s',
                },
                {
                    id: 'C', //第四张
                    position: 'absolute',
                    width: '25%',
                    height: '300px',
                    top: '10%',
                    left: '53%',
                    opacity: 3,
                    zIndex: 3,
                    transition: '.4s',
                },
                {
                    id: 'D', //第三张
                    position: 'absolute',
                    width: '25%',
                    height: '300px',
                    top: '0',
                    left: '60%',
                    marginLeft: '-22.5%',
                    opacity: 4,
                    zIndex: 2,
                    transition: '.4s',
                },
                {
                    id: 'E', //第五张
                    position: 'absolute',
                    width: '25%',
                    height: '300px',
                    top: '0',
                    left: '70%',
                    opacity: 5,
                    zIndex: 4,
                    transition: '.4s',
                },
            ],
        };
    },
    created() {},
    methods: {
        // 获取数据
        async getData() {
            this.$nextTick(() => {
                this.loading = false;
                this.imgs = this.list;
                // console.log('获取数据', this.imgs);
            });
        },
        // 滑动上一个
        prev(index) {
            // this.imgs.unshift(this.imgs.pop());
            this.config5.push(this.config5.shift());
            this.currentIndex = this.currentIndex - 1;
            if (this.currentIndex < 0) {
                this.currentIndex = this.imgs.length - 1;
            }
            this.centerCard();
            this.centerIndex('prev');
        },
        // 滑动下一个
        next() {
            // this.imgs.push(this.imgs.shift());
            this.config5.unshift(this.config5.pop());
            this.currentIndex = this.currentIndex + 1;
            if (this.currentIndex > this.imgs.length - 1) {
                this.currentIndex = 0;
            }
            this.centerCard();
            this.centerIndex('next');
            // console.log(this.currentIndex);
        },
        // 开始移动端滑动屏幕
        start(event) {
            this.startX = event.changedTouches[0].clientX;
            this.startY = event.changedTouches[0].clientY;
        },
        // 连续滑动
        move(event) {
            this.endY = event.changedTouches[0].clientY;
            this.endX = event.changedTouches[0].clientX;
            this.stopDefault(event);
            // 如果是滑动，注解（223行到231行）这段。如果是连续滑动，放开（223行到231行）注解
            this.interval = this.endX - this.startX;
            if (this.interval > 40) {
                this.startX = this.endX;
                this.prev();
            }
            if (this.interval < -40) {
                this.startX = this.endX;
                this.next();
            }
        },
        // 滑动
        end(event) {
            // 如果是滑动，放开（236行到238行）的注解。如果是连续滑动，注解（236行到238行）
            // this.endY = event.changedTouches[0].clientY;
            // this.endX = event.changedTouches[0].clientX;
            // this.formatSwiper();
        },
        formatSwiper() {
            if (this.startX > this.endX) {
                // console.log('左边滑动');
                if (this.startX > this.endX + 40) {
                    this.next();
                }
            } else {
                // console.log('右边滑动');
                if (this.endX > this.startX + 40) {
                    this.prev();
                }
            }
        },
        // 阻止touchmove的横向默认事件（ios快捷操作会关闭页面）
        stopDefault(event) {
            let differenceY = this.endY - this.startY;
            let differenceX = this.endX - this.startX;
            if (Math.abs(differenceX) > Math.abs(differenceY)) {
                event.preventDefault();
            }
        },
        // 当前imgs在位置上的index（并非img数组的index）
        centerIndex(val) {
            if (val == 'prev') {
                for (let val of this.imgs) {
                    if (val.index == this.imgs.length - 1) {
                        val.index = 0;
                    } else {
                        val.index = val.index + 1;
                    }
                }
            } else {
                for (let val of this.imgs) {
                    if (val.index == 0) {
                        val.index = this.imgs.length - 1;
                    } else {
                        val.index = val.index - 1;
                    }
                }
            }
        },
        // 点击
        chooseItem(item) {
            // console.log('index', item.id);
            this.$router.push('/details?id=' + item.id);
        },
        // 计算中间卡片信息
        centerCard() {
            this.centerInfo = this.imgs[this.currentIndex];
            this.$emit('centerInfo', this.centerInfo);
            // this.$emit('centerInfo', this.centerInfo);
            // console.log(this.imgs[2].id);
        },

        addCardStyle() {
            if (this.imgs.length > 7) {
                let addtime = this.imgs.length - 7;
                for (let i = 0; i < addtime; i++) {
                    // console.log('add');
                    this.config5.push({
                        id: 'center',
                        position: 'absolute',
                        width: '45%',
                        height: '100%',
                        top: '0px',
                        left: '50%',

                        opacity: 0,
                        transition: '.1s',
                    });
                }
            }
        },
    },
    created() {
        this.getData();
        this.centerCard(); // 获取中间卡片信息
        this.addCardStyle(); // 加入样式位置的index
    },
};
</script>

<style lang="less" scoped>
.slideshowimg {
    img {
        width: 100%;
        height: 100%;
    }
    width: 100%;
    height: 100%;
    display: flex;
    .left {
        line-height: 350px;
        font-size: 60px;
        margin-left: 10px;
    }
    .swiper {
        width: 100%;
        margin: 30px auto;
        height: 350px;
        position: relative;
        overflow: hidden;
        div {
            opacity: 0;
        }
    }
}
</style>
